import { Loader2Icon } from "lucide-react";

const Spinner = () => {
  return (
    <div className="flex items-center justify-center h-[400px]">
      <Loader2Icon className="animate-spin h-10 w-10 text-primary" />
    </div>
  );
};

export default Spinner;
